import "./layout.scss";
import "react-toastify/dist/ReactToastify.css";
import Header from "@/components/Header/Header";
import { SettingSideNav, SideNav } from "../components";
import { Outlet, useLocation } from "react-router-dom";
import { RootState } from "../store";
import { ToastContainer } from "react-toastify";
import UploadProgress from "@/components/UploadProgress/UploadProgress";
import { connect, ConnectedProps } from "react-redux";
import { toggleStateValue } from "@/store/app/app.slice";
import { useRef, useEffect } from "react";
import { useClickOutside } from "../utils";
// import Setting from '../pages/Setting/Setting';

const Layout = ({ isSideNavClose, toggleStateValue, user }: Props) => {
  const sidenavRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  const handleClickOutside = () => {
    if (!isSideNavClose) {
      toggleStateValue({ key: "isSideNavClose" });
    }
  };
  const isSettingPage = false; // location.pathname.includes('settings') || location.search.includes('settings');
  const notInsideMedia = !location.pathname.match(/^\/media\/[^/]+\/[^/]+$/);

  useEffect(() => {
    const handleCloseSideNav = () => {
      if (!isSideNavClose) {
        toggleStateValue({ key: "isSideNavClose" });
      }
    };
    window.addEventListener("closeSideNav", handleCloseSideNav);
    return () => {
      window.removeEventListener("closeSideNav", handleCloseSideNav);
    };
  }, [isSideNavClose, toggleStateValue]);

  useClickOutside(sidenavRef, handleClickOutside);

  return (
    <>
      <UploadProgress />
      <ToastContainer />
      <div className="main-layout">
        {notInsideMedia && <Header />}

        <div className={`content-container ${isSideNavClose ? "z-2" : "z-4"}`}>
          {!isSideNavClose && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 9,
              }}
            />
          )}

          {isSettingPage && (
            <SettingSideNav isSideNavClose={isSideNavClose} user={user} />
          )}

          <SideNav
            ref={sidenavRef}
            isSideNavClose={isSideNavClose}
            user={user}
          />

          <div className="main-content">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

const mapState = (state: RootState) => ({
  isSideNavClose: state.app.isSideNavClose,
  isSideNavHidden: state.app.isSideNavHidden,
  activeSideBarLink: state.app.activeSideBarLink,
  user: state.auth.user,
});

const mapDispatch = {
  toggleStateValue,
};

const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector>;
export default connector(Layout);
